import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CancelReasonStep } from "./CancelReasonStep";
import { PauseSolution, SupportSolution } from "./CancelSolutionStep";
import { CancelConfirmStep } from "./CancelConfirmStep";

export function CancelSupportModal({
    isOpen,
    onClose,
    onCancel,
    onPause,
    planName,
    isCanceling,
    isPausing,
}) {
    const { t } = useTranslation();
    const [step, setStep] = useState("reason");
    const [selectedReason, setSelectedReason] = useState(null);

    if (!isOpen) return null;

    const handleReasonSelect = (reason) => {
        setSelectedReason(reason);
        setStep(reason.solution === "confirm" ? "confirm" : "solution");
    };

    const handleContactSupport = () => {
        window.open(
            "https://calendar.app.google/r1NEgK7oWPMoUxur9",
            "_blank",
            "noopener,noreferrer"
        );
    };

    const handleConfirmCancel = async () => {
        await onCancel?.(selectedReason?.id);
        onClose();
    };

    const handlePause = async () => {
        await onPause?.();
        onClose();
    };

    const getTitle = () => {
        if (step === "reason") return t("billing.supportPlans.cancel.title");
        if (step === "solution") return t("billing.supportPlans.cancel.beforeYouGo");
        return t("billing.supportPlans.cancel.confirmTitle");
    };

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4" onClick={onClose}>
            <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
                <div className="flex items-center justify-between p-6 border-b">
                    <h2 className="text-xl font-bold">{getTitle()}</h2>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-2xl">×</button>
                </div>
                <div className="p-6">
                    {step === "reason" && <CancelReasonStep onSelectReason={handleReasonSelect} />}
                    {step === "solution" && selectedReason?.solution === "pause" && (
                        <PauseSolution onPause={handlePause} onStillCancel={() => setStep("confirm")} isPausing={isPausing} />
                    )}
                    {step === "solution" && selectedReason?.solution === "support" && (
                        <SupportSolution onContactSupport={handleContactSupport} onStillCancel={() => setStep("confirm")} />
                    )}
                    {step === "confirm" && (
                        <CancelConfirmStep planName={planName} onKeep={onClose} onConfirmCancel={handleConfirmCancel} isCanceling={isCanceling} />
                    )}
                </div>
            </div>
        </div>
    );
}
